import React, { useEffect, useState } from "react";

const Header = ({ btn, path }) => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled
          ? "bg-white/80 backdrop-blur-xl shadow-md border-b border-gray-100"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex items-center justify-between h-[85px]">
          
          {/* Logo */}
          <a
            href="/"
            className="group flex items-center gap-2 transition-all duration-300"
          >
            {/* Logo Icon */}
            <div className="w-10 h-10 rounded-2xl bg-gradient-to-br from-[#0F766E] to-[#4F46E5] flex items-center justify-center shadow-lg group-hover:scale-110 transition duration-300">
              <span className="text-white font-bold text-lg">C</span>
            </div>

            {/* Logo Text */}
            <div>
              <h1 className="text-2xl font-extrabold tracking-tight">
                <span className="text-[#0F766E]">CheX</span>
                <span className="text-[#4F46E5]">Care</span>
              </h1>

              <p className="text-[11px] text-gray-500 -mt-1 tracking-wide">
                AI Healthcare Platform
              </p>
            </div>
          </a>

          {/* Right Section */}
          <div className="flex items-center gap-4">
            
          

            {/* CTA Button */}
            <a
              href={path}
              className="relative inline-flex items-center justify-center px-6 py-3 overflow-hidden font-semibold text-white rounded-2xl bg-gradient-to-r from-[#4F46E5] to-[#6366F1] shadow-lg hover:shadow-xl hover:scale-105 transition-all duration-300"
            >
              <span className="relative z-10">{btn}</span>
            </a>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;